import Vue from "vue";
import VueRouter from "vue-router";
import formatrole from '@/helpers/formatroles.js'
import Storage from '@/helpers/storage.js'
Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "tribeId",
		component: () => import(/* webpackChunkName: "TribeId" */"@/views/TribeId.vue"),
	},
	{
		path:'/admin/login',
		name:'admin-login',
		component:() => import(/* webpackChunkName: "Login" */'@/admin/Login.vue')
	},
	{
		path:'/accounts/signup/',
		namne:'entity-signup',
		component:() => import(/* webpackChunkName: "signup" */'@/entity/SignUp.vue')
	},
	{
		path:'/accounts/signin/',
		name:'entity-login',
		component:()=> import(/* webpackChunkName: "signin" */'@/entity/SingIn.vue')
	},
	{
		path:'/admin',
		name:'admin-dashboard',
		component:() => import(/* webpackChunkName: "admindashboard" */'@/admin/AdminDashBoard.vue'),
			children: [
				{
					path:'/super_admin',
					name:'super-admin',
					component: () => import(/* webpackChunkName: "superadmin" */'@/admin/SuperAdmin.vue')
				},
				{
					path:'/global_admin',
					name:'global_admin',
					component: () => import(/* webpackChunkName: "globaladmin" */'@/admin/globaladmin/GlobalAdmin.vue')
				},
				{
					path:'/market_admin',
					name:'market_admin',
					component:()=> import(/* webpackChunkName: "marketadmin" */'@/admin/marketadmin/MarketAdminHome.vue')
				},
				{
					path:'/markets',
					name:'markets',
					component:() => import(/* webpackChunkName: "markets" */'@/admin/marketadmin/Markets.vue')
				},
				{
					path:'/settings',
					name:'settings',
					component:()=> import(/* webpackChunkName: "changepasword" */'../admin/ChangePassword.vue')
				}
			]
	},
	{
		path:'*',
		component:()=> import(/* webpackChunkName: "404" */'@/components/404.vue')
	}
];


const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,	
});

// redirectin and access control 

const admin = Storage.get('dashboard')
if( admin ) {
	router.beforeEach( (to,from,next)=> {
		if(to.path === '/admin') {
			next(`${admin.links.sidebar[0].route}`)
		}
			next()	
	})
}


export default router;
